var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"service":"VersionLogs","messages":_vm.messages,"mypopup":_vm.mypopup,"headers":_vm.headers,"sanitize":_vm.sanitize,"show-actions":"new, edit, delete, import, export"},scopedSlots:_vm._u([{key:"form",fn:function({ value, listeners }){return [_c('VersionLog',_vm._g({staticClass:"pa-4",attrs:{"value":value}},listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }